import React, { useEffect } from 'react';
import Modal from '@atlaskit/modal-dialog';
import { useDatasourceAnalyticsEvents } from '../../../../analytics';
var ScreenEvent = function ScreenEvent() {
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('screen.datasourceModalDialog.viewed', {});
  }, [fireEvent]);
  return null;
};
export var DatasourceModal = function DatasourceModal(_ref) {
  var testId = _ref.testId,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Modal, {
    testId: testId,
    onClose: onClose,
    width: "calc(100% - 80px)",
    shouldScrollInViewport: true,
    shouldReturnFocus: false
  }, /*#__PURE__*/React.createElement(ScreenEvent, null), children);
};